module.exports = __webpack_public_path__ + "static/media/STFU-1.3f6d4d21.png";